import { Avatar, Box, Button, Card, CardActions, CardContent, CardHeader, Divider, FormControl, Grid, IconButton, InputLabel, List, ListItem, ListItemAvatar, ListItemText, MenuItem, OutlinedInput, Select, Stack, Typography } from "@mui/material";
import { useUser } from "../../context/userContext";
import { TrophyIcon } from "@phosphor-icons/react";
import { UpdatePasswordForm } from "./updatePasswordForm";
import UpdateUserDetailsForm from "./updateUserDetailsForm";
import { useEffect, useState } from "react";
import { getAgentDetailsByAgentId } from "../../api/userApi";

export function UserProfile() {
    const { user } = useUser();
    // Get user roles from context
    const userRoles = Array.isArray(user?.roles) ? user.roles : [];
    const [userDetails, setUserDetails] = useState();

    const fetchAgentDetails = async () => {
        // You can use the user data to pre-fill the form fields if needed
        // For example:
        // setAlias(user.alias || '');
        try {
            const response = await getAgentDetailsByAgentId(user.userId);
            setUserDetails(response.data);
            console.log("Agent Details:", response.data);
        }
        catch (error) {
            console.error("Error fetching agent details:", error);
        }
    };

    useEffect(() => {
        fetchAgentDetails();
    }, [user.userId]);

    const commission = [
        { id: 'PSC', name: 'Personal Sales Commission', percentage: userDetails?.personalComm + '%' || '0%' },
        { id: 'DOC', name: 'Downline Override Commission', percentage: userDetails?.downlineOverridingComm + '%' || '0%' },
        { id: 'TOC', name: 'Team Override Commission', percentage: userDetails?.teamOverridingComm + '%' || '0%' }
    ];

    return (
        <Box className="container" sx={{ pt: 2, pb: 4 }}>
            <Stack spacing={3}>
                {/* <Box sx={{ mt: 8, mb: 2 }}>
                    <Typography
                        variant="h5"
                        sx={{
                            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                            fontWeight: 'bold'
                        }}
                    >
                        User Profile
                    </Typography>
                </Box> */}
                <Grid container spacing={3}>
                    {/* Left Column: User Info & Commission */}
                    <Grid size={{ lg: 4, md: 6, xs: 12 }}>
                        <Stack spacing={3}>
                            {/* Card 1: User Info */}
                            <Card>
                                <CardContent>
                                    <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
                                        <Avatar src={user.avatar} sx={{ height: '80px', width: '80px' }} />
                                        <Stack spacing={0.5}>
                                            <Typography variant="h5">{user.name}</Typography>
                                            <Typography color="text.secondary" variant="body2">
                                                {userRoles.join(', ')}
                                            </Typography>
                                            <Typography color="text.secondary" variant="body2">
                                                {user.group || "Team Name"}
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                </CardContent>
                                <Divider />
                                <CardActions>
                                    <Button fullWidth variant="text" disabled>
                                        Upload picture
                                    </Button>
                                </CardActions>
                            </Card>

                            {/* Card 2: Commission */}
                            <Card>
                                <CardHeader
                                    avatar={<TrophyIcon size={20} color="#000000" />}
                                    title="Commission"
                                    titleTypographyProps={{ variant: 'h6' }}
                                />
                                <Divider />
                                <List>
                                    {commission.map((item, index) => (
                                        <ListItem
                                            divider={index < commission.length - 1}
                                            key={item.id}
                                            secondaryAction={
                                                <Typography variant="h6" sx={{ color: '#4636f5' }}>
                                                    {item.percentage}
                                                </Typography>
                                            }
                                        >
                                            <ListItemText
                                                primary={item.id}
                                                primaryTypographyProps={{ variant: 'subtitle2', color: 'text.primary' }}
                                                secondary={item.name}
                                                secondaryTypographyProps={{ variant: 'caption', color: 'text.secondary' }}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Card>
                        </Stack>
                    </Grid>

                    {/* Right Column: Edit Profile & Update Password */}
                    <Grid size={{ lg: 8, md: 6, xs: 12 }}>
                        <Stack spacing={3}>
                            {/* Form 1: Edit Profile */}
                            <Card>
                                <CardContent>
                                    <UpdateUserDetailsForm
                                        userDetails={userDetails}
                                        setUserDetails={setUserDetails}
                                    />
                                </CardContent>
                            </Card>
                            {/* <form onSubmit={(e) => e.preventDefault()}>
                                <Card>
                                    <CardHeader subheader="The information can be edited" title="Profile" />
                                    <Divider />
                                    <CardContent>
                                        <Grid container spacing={3}>
                                            <Grid item md={12} xs={12}>
                                                <FormControl fullWidth required>
                                                    <InputLabel>Name</InputLabel>
                                                    <OutlinedInput defaultValue={user.name} label="Name" name="name" />
                                                </FormControl>
                                            </Grid>
                                            <Grid item md={6} xs={12}>
                                                <FormControl fullWidth required>
                                                    <InputLabel>Email address</InputLabel>
                                                    <OutlinedInput defaultValue={user.email} label="Email address" name="email" />
                                                </FormControl>
                                            </Grid>
                                            <Grid item md={6} xs={12}>
                                                <FormControl fullWidth>
                                                    <InputLabel>Phone number</InputLabel>
                                                    <OutlinedInput defaultValue={user.phone} label="Phone number" name="phone" type="tel" />
                                                </FormControl>
                                            </Grid>
                                            <Grid item md={12} xs={12}>
                                                <FormControl fullWidth>
                                                    <InputLabel>Address</InputLabel>
                                                    <OutlinedInput defaultValue={user.address} label="Address" name="address" />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                    <Divider />
                                    <CardActions sx={{ justifyContent: 'flex-end' }}>
                                        <Button variant="contained">Save</Button>
                                    </CardActions>
                                </Card>
                            </form> */}

                            {/* Form 2: Update Password */}
                            <Card>
                                <CardContent>
                                    <UpdatePasswordForm />
                                </CardContent>
                            </Card>
                        </Stack>
                    </Grid>
                </Grid>
            </Stack>
        </Box>
    );
}